import React, { useRef, useState, useEffect } from "react";
import { Box, Divider } from "digiwash-components";
import { Video as VideoFile } from "expo-av";
import { TouchableOpacity, Platform } from "react-native";
import CustomIcon from "../CustomIcon";
import { HomePageVideosType } from "../../types/server";
import BoxRatio from "../BoxRatio";
import { boxRatioWidth } from "../../helpers/general";

interface PropsType {
  data: HomePageVideosType[];
}

function Video(props: PropsType) {
  let videoRef = useRef(null);
  let [showPlayButton, setShowPlayButton] = useState(true);
  let [isPlaying, setIsPlaying] = useState<boolean>();
  let [hasEnded, setHasEnded] = useState<boolean>();

  useEffect(() => {
    if (Platform.OS === "android" && hasEnded) {
      videoRef.current.pauseAsync();
    }
  }, [hasEnded]);

  return (
    <Box>
      {props.data.map((item, index) => {
        let isLastItem = props.data.length === index + 1;

        return (
          <>
            <TouchableOpacity
              onPress={(e) => {
                e.preventDefault();
                setShowPlayButton(false);
                if (isPlaying) {
                  videoRef.current.pauseAsync();
                } else {
                  videoRef.current.playAsync();
                }
              }}
            >
              <Box
                style={{
                  width: "100%",
                  overflow: "hidden",
                  position: "relative",
                  justifyContent: "center",
                  alignItems: "center",
                }}
                br="s"
              >
                <BoxRatio
                  ratio={item.ratio}
                  fixedWidth={boxRatioWidth({
                    columns: 1,
                    padding: ["xxl", "xxl"],
                  })}
                >
                  <VideoFile
                    ref={videoRef}
                    source={{
                      uri: item.url,
                    }}
                    posterSource={{
                      uri: item.cover,
                    }}
                    style={{
                      width: "100%",
                      height: "100%",
                    }}
                    resizeMode="contain"
                    usePoster={true}
                    positionMillis={hasEnded ? 0 : undefined}
                    useNativeControls={true}
                    onPlaybackStatusUpdate={(status) => {
                      if (status.isLoaded) {
                        setIsPlaying(status.isPlaying);
                        setHasEnded(status.didJustFinish);
                      }
                    }}
                  />
                </BoxRatio>
                {showPlayButton ? (
                  <Box
                    br="circle"
                    p="xm"
                    style={{
                      width: 64,
                      height: 64,
                      position: "absolute",
                      alignItems: "center",
                      justifyContent: "center",
                      boxShadow: "0px 0px 8px rgba(33, 33, 33, 0.24)",
                    }}
                    bg="common.white"
                  >
                    <CustomIcon icon="play" width={24} height={24} />
                  </Box>
                ) : null}
              </Box>
            </TouchableOpacity>

            {isLastItem ? null : <Divider size="xxl" />}
          </>
        );
      })}
    </Box>
  );
}

export default Video;
